import { addAll21mdhg523wnoa as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { CoroutineContext3n9ge8bnnq7z2 as CoroutineContext } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function coroutineContextOf(elements) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MutableCoroutineContext())();
  addAll(this_0.list_1, elements);
  return this_0;
}
var MutableCoroutineContextClass;
function MutableCoroutineContext() {
  if (MutableCoroutineContextClass === VOID) {
    class $ {
      constructor() {
        this.list_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      add_obqr7s_k$(context) {
        context.fold_j2vaxd_k$(Unit_instance, (_unused_var__etf5q3, element) => {
          this.add_5k7gyg_k$(element);
          return Unit_instance;
        });
      }
      add_5k7gyg_k$(element) {
        this.list_1.add_utx5q5_k$(element);
      }
      fold_j2vaxd_k$(initial, operation) {
        // Inline function 'kotlin.collections.fold' call
        var accumulator = initial;
        var _iterator__ex2g4s = this.list_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          accumulator = operation(accumulator, element);
        }
        return accumulator;
      }
      get_y2st91_k$(key) {
        var inductionVariable = get_lastIndex(this.list_1);
        if (0 <= inductionVariable)
          $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var tmp0_elvis_lhs = this.list_1.get_c1px32_k$(index).get_y2st91_k$(key);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            return tmp;
          }
           while (0 <= inductionVariable);
        return null;
      }
      minusKey_9i5ggf_k$(key) {
        var elements = this.list_1;
        // Inline function 'com.lightningkite.kiteui.views.buildCoroutineContext' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (MutableCoroutineContext())();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (element.get_y2st91_k$(key) == null) {
            this_0.add_5k7gyg_k$(element);
          }
        }
        return this_0;
      }
      plus_s13ygv_k$(context) {
        var tmp;
        if (context === EmptyCoroutineContext_instance) {
          tmp = this;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.buildCoroutineContext' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (MutableCoroutineContext())();
          this_0.list_1.addAll_4lah1e_k$(this.list_1);
          this_0.add_obqr7s_k$(context);
          tmp = this_0;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'MutableCoroutineContext', MutableCoroutineContext, VOID, [CoroutineContext()]);
    MutableCoroutineContextClass = $;
  }
  return MutableCoroutineContextClass;
}
//region block: exports
export {
  coroutineContextOf as coroutineContextOf2kr7rpdapvlde,
};
//endregion

//# sourceMappingURL=MutableCoroutineContext.mjs.map
